var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap align-center"},[_c('div',{style:({
      'width': _vm.datePickerWidth
    })},[_c('Datepicker',{attrs:{"solo":_vm.solo,"filled":_vm.filled,"label":_vm.label,"prependIcon":_vm.datePickerPrependIcon,"appendIcon":_vm.datePickerAppendIcon},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1),_c('TimePicker',{attrs:{"label":null},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }